import SectionLabel from "./SectionLabel";
import { FadeUp, MaskLine } from "./Reveal";

const steps = [
  {
    n: "01",
    title: "Assess Your Position",
    q: "Where are you right now?",
    body: "Before determining where you're going, you have to honestly understand where you are.",
  },
  {
    n: "02",
    title: "Identify The Gaps",
    q: "What don't you know yet?",
    body: "Sometimes the problem isn't that you don't have the answer. Sometimes you haven't identified the information that's missing.",
  },
  {
    n: "03",
    title: "Gather Intelligence",
    q: "Where can you find what you need?",
    body: "Intelligence may come through Heaven. Through self-awareness. Through strategy. Through relationships. Through resources.",
  },
  {
    n: "04",
    title: "Exchange What You Carry",
    q: "The room is a resource.",
    body: "You are not entering as an empty vessel waiting to be filled. You carry experience, wisdom, perspective, relationships, knowledge, lessons — and someone in the room may need what you know.",
  },
  {
    n: "05",
    title: "Determine Your Next Move",
    q: "Now what?",
    body: "What do you know now? What still requires prayer, research, conversation, or discernment? Who do you need to contact? What might your next move be?",
  },
];

export default function Experience() {
  return (
    <section data-testid="experience-section" className="border-b border-ink/15">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
        <SectionLabel testid="experience-label">The Mission</SectionLabel>

        <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
          <MaskLine>Pause. Assess.</MaskLine>
          <MaskLine delay={0.1}>
            Gather. <span className="italic text-wine">Move.</span>
          </MaskLine>
        </h2>

        <FadeUp delay={0.2} className="mt-8 max-w-2xl">
          <p className="text-base leading-relaxed text-smoke md:text-lg">
            RECON is designed as an experience — not simply a series of sessions. Every woman enters
            with a current position. A question. A decision. A burden. An assignment. And throughout
            the experience, she moves through the RECON intelligence journey.
          </p>
        </FadeUp>

        <div className="mt-20">
          {steps.map((step, i) => (
            <FadeUp key={step.n} delay={i * 0.06}>
              <div
                data-testid={`experience-step-${step.n}`}
                className="group grid gap-4 border-b border-ink/15 py-10 transition-colors duration-300 md:grid-cols-12 md:items-baseline"
              >
                <span className="font-serif text-6xl font-light text-ink/15 transition-colors duration-300 group-hover:text-gold md:col-span-2 md:text-7xl">
                  {step.n}
                </span>
                <div className="md:col-span-4">
                  <h3 className="font-sans text-sm font-semibold uppercase tracking-[0.25em] text-ink">
                    {step.title}
                  </h3>
                  <p className="mt-2 font-serif text-xl italic text-wine">{step.q}</p>
                </div>
                <p className="text-sm leading-relaxed text-smoke md:col-span-6 md:text-base">
                  {step.body}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
}
